module.exports = __webpack_public_path__ + "img/p3.a556b40e.png";